import AES from 'crypto-js/aes';

import { APIS } from '~constants/index';
import { useLocalStorage, type UserStorage } from '~hooks/index';
import { sendRequest } from '~utils/index';

export const updateUserStorage = () => {
  const { updateUserData } = useLocalStorage();

  sendRequest<UserStorage>({
    url: APIS.MANAGE_USERS.USERS,
    thenFunction: async (res) => {
      if (res.status === 200) {
        updateUserData(res.data);
        await getSidebarData();
      }
    }
  });
};

export const getSidebarData = async () => {
  const { updateUserData } = useLocalStorage();

  await sendRequest({
    url: APIS.CORE.NAV_BAR,
    thenFunction: (res) => {
      if (res.status === 200) {
        updateUserData({ sidebarData: res.data });
        window.location.reload();
      } else updateUserData({ sidebarData: [] });
    },
    catchFunction: () => updateUserData({ sidebarData: [] })
  });
};

interface Props {
  document_number: string;
  setCode: Setter<string | null>;
}
export const createCode = async ({ document_number, setCode }: Props) => {
  await sendRequest<{ code: string }>({
    url: APIS.LACARDIO.LOGIN,
    params: {
      document_number
    },
    thenFunction: (res) => {
      if (res.status === 200) {
        setCode(res.data.code);
      }
    }
  });
};

interface UserDataKhymei {
  username: string;
  password: string;
}

const encryptKhymeiUserData = (data: UserDataKhymei) => {
  const dataEncrypted = AES.encrypt(
    JSON.stringify(data),
    import.meta.env.VITE_ENCRYPTION_KEY_KARYA
  ).toString();
  return dataEncrypted;
};
/* const decryptKaryaUserData = (data) => {
  let userDataDecrypted = {};
  if (data !== null) {
    const bytes = AES.decrypt(data, import.meta.env.VITE_ENCRYPTION_KEY_KARYA);
    userDataDecrypted = JSON.parse(bytes.toString(Utf8));
  }
  return userDataDecrypted;
}; */
export const loginKhymeiRequests = ({
  credentials,
  tenant
}: {
  credentials: UserDataKhymei;
  tenant: string;
}) => {
  const encryptedKey = encryptKhymeiUserData(credentials);
  const base = 'https://khymei.ticsocial.com.co/redirect/';
  const url = `${base}?tenant=${tenant}&key=${encryptedKey}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
